// // // "use client";

// // // import React, { useRef, useEffect, useMemo } from "react";

// // // /**
// // //  * Minimal, allowlist-based sanitizer that:
// // //  *  - drops <script>, <style>, <iframe>, <object>, <embed>, <link>, <meta>
// // //  *  - removes event handlers (on*)
// // //  *  - cleans javascript: URLs
// // //  *  - preserves common formatting tags and attributes (class, style, href)
// // //  */
// // // function sanitizeHtml(input) {
// // //   if (typeof window === "undefined") return input || "";
// // //   const ALLOWED_TAGS = new Set([
// // //     "div","p","span","strong","b","em","i","u","a","ul","ol","li",
// // //     "br","hr","h1","h2","h3","h4","h5","h6","blockquote","code","pre",
// // //     "table","thead","tbody","tr","th","td","img"
// // //   ]);
// // //   const DANGEROUS_TAGS = new Set(["script","style","iframe","object","embed","link","meta"]);
// // //   const ALLOWED_ATTRS = new Set(["class","style","href","target","rel","src","alt","title","data-bound"]);

// // //   const tpl = document.createElement("template");
// // //   tpl.innerHTML = String(input || "");

// // //   const walk = (node) => {
// // //     // remove dangerous tags entirely
// // //     if (node.nodeType === 1) {
// // //       const tag = node.tagName.toLowerCase();
// // //       if (DANGEROUS_TAGS.has(tag) || (!ALLOWED_TAGS.has(tag) && tag !== "body")) {
// // //         node.remove();
// // //         return;
// // //       }
// // //       // scrub attributes
// // //       [...node.attributes].forEach((attr) => {
// // //         const name = attr.name.toLowerCase();
// // //         if (!ALLOWED_ATTRS.has(name) && !name.startsWith("data-")) node.removeAttribute(attr.name);
// // //         if (name.startsWith("on")) node.removeAttribute(attr.name);
// // //         if (name === "href" || name === "src") {
// // //           const val = (attr.value || "").trim();
// // //           if (/^\s*javascript:/i.test(val)) node.removeAttribute(attr.name);
// // //         }
// // //       });
// // //     }
// // //     // traverse children
// // //     [...node.childNodes].forEach(walk);
// // //   };

// // //   // Work on a wrapper to retain full fragment
// // //   const wrapper = document.createElement("div");
// // //   wrapper.appendChild(tpl.content.cloneNode(true));
// // //   walk(wrapper);
// // //   return wrapper.innerHTML;
// // // }

// // // function escapeHtml(text = "") {
// // //   return String(text)
// // //     .replace(/&/g, "&amp;")
// // //     .replace(/</g, "&lt;")
// // //     .replace(/>/g, "&gt;")
// // //     .replace(/"/g, "&quot;");
// // // }

// // // /**
// // //  * Replace {{tokens}} with bound values.
// // //  * Special handling:
// // //  *  - {{experience}} is hidden if include_experience === false
// // //  *  - Empty bindings fall back to friendly defaults
// // //  *  - Bound replacements are wrapped in <span data-bound="key"> for clarity
// // //  */
// // // function applyBindingsToHtml(rawHtml, bindings) {
// // //   const {
// // //     experience = "",
// // //     include_experience = true,
// // //     signature = "",
// // //     closing = "",
// // //     rec_strength = "",
// // //     strength_rating = "",
// // //   } = bindings || {};

// // //   const defaults = {
// // //     experience: "—",
// // //     signature: "Your Name",
// // //     closing: "Sincerely,",
// // //     rec_strength: "strongly",
// // //     strength_rating: "5",
// // //   };

// // //   let html = String(rawHtml || "");

// // //   // Handle experience toggle early (so {{experience}} -> "" if excluded)
// // //   const expVal = include_experience
// // //     ? (experience || defaults.experience)
// // //     : "";

// // //   const map = {
// // //     experience: expVal,
// // //     signature: signature || defaults.signature,
// // //     closing: closing || defaults.closing,
// // //     rec_strength: rec_strength || defaults.rec_strength,
// // //     strength_rating: strength_rating || defaults.strength_rating,
// // //   };

// // //   html = html.replace(/{{\s*(experience|signature|closing|rec_strength|strength_rating)\s*}}/g, (_, key) => {
// // //     const value = escapeHtml(map[key] ?? "");
// // //     // If experience is excluded, return empty string; else wrap with marker.
// // //     if (key === "experience" && !include_experience) return "";
// // //     return `<span data-bound="${key}">${value}</span>`;
// // //   });

// // //   return html;
// // // }

// // // /**
// // //  * Preserve and restore caret position across innerHTML updates.
// // //  * We approximate by remembering an offset into textContent.
// // //  */
// // // function saveCaret(container) {
// // //   const sel = window.getSelection?.();
// // //   if (!sel || sel.rangeCount === 0) return null;
// // //   const range = sel.getRangeAt(0);
// // //   if (!container.contains(range.startContainer)) return null;

// // //   // Compute character offset from container start
// // //   const preRange = range.cloneRange();
// // //   preRange.selectNodeContents(container);
// // //   preRange.setEnd(range.startContainer, range.startOffset);
// // //   const offset = preRange.toString().length;
// // //   return { offset };
// // // }

// // // function restoreCaret(container, saved) {
// // //   if (!saved) return;
// // //   const targetOffset = saved.offset ?? 0;
// // //   const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
// // //   let node, count = 0;
// // //   while ((node = walker.nextNode())) {
// // //     const next = count + node.textContent.length;
// // //     if (targetOffset <= next) {
// // //       const range = document.createRange();
// // //       const within = Math.max(0, targetOffset - count);
// // //       range.setStart(node, within);
// // //       range.collapse(true);
// // //       const sel = window.getSelection?.();
// // //       if (sel) {
// // //         sel.removeAllRanges();
// // //         sel.addRange(range);
// // //       }
// // //       return;
// // //     }
// // //     count = next;
// // //   }
// // // }

// // // /**
// // //  * Component
// // //  */
// // // export default function ({ html, onHtmlChange, bindings = {} }) {
// // //   const containerRef = useRef(null);

// // //   // Compute sanitized, bound HTML that should be rendered
// // //   const computedHtml = useMemo(() => {
// // //     const withBindings = applyBindingsToHtml(html, bindings);
// // //     return sanitizeHtml(withBindings);
// // //   }, [html, bindings]);

// // //   // Sync innerHTML when parent html/bindings change (preserve caret if focused)
// // //   useEffect(() => {
// // //     const el = containerRef.current;
// // //     if (!el) return;

// // //     const isFocused = document.activeElement === el;
// // //     const caret = isFocused ? saveCaret(el) : null;

// // //     if (el.innerHTML !== computedHtml) {
// // //       el.innerHTML = computedHtml;
// // //     }

// // //     if (isFocused) restoreCaret(el, caret);
// // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // //   }, [computedHtml]);

// // //   // Propagate edits upward with sanitized HTML
// // //   const handleInput = () => {
// // //     if (!containerRef.current || !onHtmlChange) return;
// // //     const current = sanitizeHtml(containerRef.current.innerHTML);
// // //     onHtmlChange(current);
// // //   };

// // //   // Paste handler: prefer clean plaintext; fallback to sanitized HTML
// // //   const handlePaste = (e) => {
// // //     const clipboard = e.clipboardData;
// // //     if (!clipboard) return; // let default happen

// // //     const text = clipboard.getData("text/plain");
// // //     if (text) {
// // //       e.preventDefault();
// // //       document.execCommand("insertText", false, text);
// // //       handleInput();
// // //       return;
// // //     }

// // //     const html = clipboard.getData("text/html");
// // //     if (html) {
// // //       e.preventDefault();
// // //       document.execCommand("insertHTML", false, sanitizeHtml(html));
// // //       handleInput();
// // //     }
// // //   };

// // //   return (
// // //     <div
// // //       ref={containerRef}
// // //       contentEditable
// // //       onInput={handleInput}
// // //       onPaste={handlePaste}
// // //       suppressContentEditableWarning
// // //       className="prose max-w-none focus:outline-none p-6 rounded-xl border border-gray-200 bg-white shadow-sm"
// // //       style={{ overflowWrap: "break-word" }}
// // //       aria-label="Editable Email Template Preview"
// // //     />
// // //   );
// // // }


// // "use client";

// // import React, { useRef, useEffect, useMemo } from "react";

// // /**
// //  * Minimal, allowlist-based sanitizer that:
// //  *  - drops <script>, <style>, <iframe>, <object>, <embed>, <link>, <meta>
// //  *  - removes event handlers (on*)
// //  *  - cleans javascript: URLs
// //  *  - preserves common formatting tags and attributes (class, style, href)
// //  */
// // function sanitizeHtml(input) {
// //   if (typeof window === "undefined") return input || "";
// //   const ALLOWED_TAGS = new Set([
// //     "div","p","span","strong","b","em","i","u","a","ul","ol","li",
// //     "br","hr","h1","h2","h3","h4","h5","h6","blockquote","code","pre",
// //     "table","thead","tbody","tr","th","td","img"
// //   ]);
// //   const DANGEROUS_TAGS = new Set(["script","style","iframe","object","embed","link","meta"]);
// //   const ALLOWED_ATTRS = new Set(["class","style","href","target","rel","src","alt","title","data-bound"]);

// //   const tpl = document.createElement("template");
// //   tpl.innerHTML = String(input || "");

// //   const walk = (node) => {
// //     // remove dangerous tags entirely
// //     if (node.nodeType === 1) {
// //       const tag = node.tagName.toLowerCase();
// //       if (DANGEROUS_TAGS.has(tag) || (!ALLOWED_TAGS.has(tag) && tag !== "body")) {
// //         node.remove();
// //         return;
// //       }
// //       // scrub attributes
// //       [...node.attributes].forEach((attr) => {
// //         const name = attr.name.toLowerCase();
// //         if (!ALLOWED_ATTRS.has(name) && !name.startsWith("data-")) node.removeAttribute(attr.name);
// //         if (name.startsWith("on")) node.removeAttribute(attr.name);
// //         if (name === "href" || name === "src") {
// //           const val = (attr.value || "").trim();
// //           if (/^\s*javascript:/i.test(val)) node.removeAttribute(attr.name);
// //         }
// //       });
// //     }
// //     // traverse children
// //     [...node.childNodes].forEach(walk);
// //   };

// //   // Work on a wrapper to retain full fragment
// //   const wrapper = document.createElement("div");
// //   wrapper.appendChild(tpl.content.cloneNode(true));
// //   walk(wrapper);
// //   return wrapper.innerHTML;
// // }

// // function escapeHtml(text = "") {
// //   return String(text)
// //     .replace(/&/g, "&amp;")
// //     .replace(/</g, "&lt;")
// //     .replace(/>/g, "&gt;")
// //     .replace(/"/g, "&quot;");
// // }

// // /**
// //  * Replace {{tokens}} with bound values.
// //  * Supports:
// //  *  - {{experience}}, {{signature}}, {{closing}}, {{rec_strength}}, {{strength_rating}}
// //  *  - {{achievements}}, {{hard_skills}}, {{soft_skills}}, {{reasons}}, {{story}}
// //  * Special handling:
// //  *  - tokens obey include_* flags (e.g., include_experience, include_reasons)
// //  *  - Empty bindings fall back to friendly defaults where sensible
// //  *  - Newlines in values are rendered as <br> for better readability
// //  *  - Bound replacements are wrapped in <span data-bound="key">
// //  */
// // function applyBindingsToHtml(rawHtml, bindings) {
// //   const {
// //     // Core
// //     experience = "",
// //     include_experience = true,
// //     signature = "",
// //     closing = "",
// //     rec_strength = "",
// //     strength_rating = "",

// //     // Evidence fields (new)
// //     achievements = "",
// //     include_achievements = true,
// //     hard_skills = "",
// //     include_hard_skills = true,
// //     soft_skills = "",
// //     include_soft_skills = true,
// //     reasons = "",
// //     include_reasons = true,
// //     story = "",
// //     include_story = true,
// //   } = bindings || {};

// //   const defaults = {
// //     experience: "—",
// //     signature: "Your Name",
// //     closing: "Sincerely,",
// //     rec_strength: "strongly",
// //     strength_rating: "5",
// //     achievements: "",
// //     hard_skills: "",
// //     soft_skills: "",
// //     reasons: "",
// //     story: "",
// //   };

// //   let html = String(rawHtml || "");

// //   // inclusion switches
// //   const includeSwitch = {
// //     experience: include_experience,
// //     achievements: include_achievements,
// //     hard_skills: include_hard_skills,
// //     soft_skills: include_soft_skills,
// //     reasons: include_reasons,
// //     story: include_story,
// //   };

// //   const map = {
// //     experience: include_experience ? (experience || defaults.experience) : "",
// //     signature: signature || defaults.signature,
// //     closing: closing || defaults.closing,
// //     rec_strength: rec_strength || defaults.rec_strength,
// //     strength_rating: strength_rating || defaults.strength_rating,

// //     achievements: include_achievements ? (achievements || defaults.achievements) : "",
// //     hard_skills: include_hard_skills ? (hard_skills || defaults.hard_skills) : "",
// //     soft_skills: include_soft_skills ? (soft_skills || defaults.soft_skills) : "",
// //     reasons: include_reasons ? (reasons || defaults.reasons) : "",
// //     story: include_story ? (story || defaults.story) : "",
// //   };

// //   // Replace tokens (now includes evidence tokens)
// //   html = html.replace(
// //     /{{\s*(experience|signature|closing|rec_strength|strength_rating|achievements|hard_skills|soft_skills|reasons|story)\s*}}/g,
// //     (_, key) => {
// //       // honor include_* toggles
// //       if (key in includeSwitch && !includeSwitch[key]) return "";
// //       // escape, then preserve newlines for readability
// //       const htmlValue = escapeHtml(map[key] ?? "").replace(/\n/g, "<br>");
// //       return `<span data-bound="${key}">${htmlValue}</span>`;
// //     }
// //   );

// //   return html;
// // }

// // /**
// //  * Preserve and restore caret position across innerHTML updates.
// //  * We approximate by remembering an offset into textContent.
// //  */
// // function saveCaret(container) {
// //   const sel = window.getSelection?.();
// //   if (!sel || sel.rangeCount === 0) return null;
// //   const range = sel.getRangeAt(0);
// //   if (!container.contains(range.startContainer)) return null;

// //   // Compute character offset from container start
// //   const preRange = range.cloneRange();
// //   preRange.selectNodeContents(container);
// //   preRange.setEnd(range.startContainer, range.startOffset);
// //   const offset = preRange.toString().length;
// //   return { offset };
// // }

// // function restoreCaret(container, saved) {
// //   if (!saved) return;
// //   const targetOffset = saved.offset ?? 0;
// //   const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
// //   let node, count = 0;
// //   while ((node = walker.nextNode())) {
// //     const next = count + node.textContent.length;
// //     if (targetOffset <= next) {
// //       const range = document.createRange();
// //       const within = Math.max(0, targetOffset - count);
// //       range.setStart(node, within);
// //       range.collapse(true);
// //       const sel = window.getSelection?.();
// //       if (sel) {
// //         sel.removeAllRanges();
// //         sel.addRange(range);
// //       }
// //       return;
// //     }
// //     count = next;
// //   }
// // }

// // /**
// //  * Component
// //  */
// // export default function LetterPreviewTemp({ html, onHtmlChange, bindings = {} }) {
// //   const containerRef = useRef(null);

// //   // Compute sanitized, bound HTML that should be rendered
// //   const computedHtml = useMemo(() => {
// //     const withBindings = applyBindingsToHtml(html, bindings);
// //     return sanitizeHtml(withBindings);
// //   }, [html, bindings]);

// //   // Sync innerHTML when parent html/bindings change (preserve caret if focused)
// //   useEffect(() => {
// //     const el = containerRef.current;
// //     if (!el) return;

// //     const isFocused = document.activeElement === el;
// //     const caret = isFocused ? saveCaret(el) : null;

// //     if (el.innerHTML !== computedHtml) {
// //       el.innerHTML = computedHtml;
// //     }

// //     if (isFocused) restoreCaret(el, caret);
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [computedHtml]);

// //   // Propagate edits upward with sanitized HTML
// //   const handleInput = () => {
// //     if (!containerRef.current || !onHtmlChange) return;
// //     const current = sanitizeHtml(containerRef.current.innerHTML);
// //     onHtmlChange(current);
// //   };

// //   // Paste handler: prefer clean plaintext; fallback to sanitized HTML
// //   const handlePaste = (e) => {
// //     const clipboard = e.clipboardData;
// //     if (!clipboard) return; // let default happen

// //     const text = clipboard.getData("text/plain");
// //     if (text) {
// //       e.preventDefault();
// //       document.execCommand("insertText", false, text);
// //       handleInput();
// //       return;
// //     }

// //     const html = clipboard.getData("text/html");
// //     if (html) {
// //       e.preventDefault();
// //       document.execCommand("insertHTML", false, sanitizeHtml(html));
// //       handleInput();
// //     }
// //   };

// //   return (
// //     <div
// //       ref={containerRef}
// //       contentEditable
// //       onInput={handleInput}
// //       onPaste={handlePaste}
// //       suppressContentEditableWarning
// //       className="prose max-w-none focus:outline-none p-6 rounded-xl border border-gray-200 bg-white shadow-sm"
// //       style={{ overflowWrap: "break-word" }}
// //       aria-label="Editable Letter Template Preview"
// //       spellCheck={true}
// //     />
// //   );
// // }


// "use client";

// import React, { useRef, useEffect, useMemo } from "react";

// /**
//  * Minimal, allowlist-based sanitizer that:
//  *  - drops <script>, <style>, <iframe>, <object>, <embed>, <link>, <meta>
//  *  - removes event handlers (on*)
//  *  - cleans javascript: URLs
//  *  - minimally scrubs style= values (blocks expression(), url(javascript:))
//  *  - preserves common formatting + structural tags and useful attributes
//  */
// function sanitizeHtml(input) {
//   if (typeof window === "undefined") return input || "";

//   const ALLOWED_TAGS = new Set([
//     // text / formatting
//     "div","p","span","strong","b","em","i","u","a","ul","ol","li",
//     "br","hr","h1","h2","h3","h4","h5","h6","blockquote","code","pre",
//     "table","thead","tbody","tr","th","td","img","sup","sub",
//     // common structure wrappers that may appear in templates
//     "article","section","header","footer","address"
//   ]);

//   const DANGEROUS_TAGS = new Set([
//     "script","style","iframe","object","embed","link","meta"
//   ]);

//   const ALLOWED_ATTRS = new Set([
//     "class","style","href","target","rel","src","alt","title","data-bound"
//   ]);

//   const tpl = document.createElement("template");
//   tpl.innerHTML = String(input || "");

//   const scrubStyleValue = (val) => {
//     if (!val) return "";
//     let out = String(val);
//     // block JS execution paths
//     out = out.replace(/expression\s*\(/gi, "");
//     out = out.replace(/url\s*\(\s*['"]?\s*javascript\s*:/gi, "url(");
//     return out;
//   };

//   const walk = (node) => {
//     if (node.nodeType === 1) {
//       const tag = node.tagName.toLowerCase();

//       // Remove dangerous or unknown tags (except body, which template parser may synthesize)
//       if (DANGEROUS_TAGS.has(tag) || (!ALLOWED_TAGS.has(tag) && tag !== "body")) {
//         node.remove();
//         return;
//       }

//       // Scrub attributes
//       [...node.attributes].forEach((attr) => {
//         const name = attr.name.toLowerCase();

//         // Remove any inline event handlers
//         if (name.startsWith("on")) {
//           node.removeAttribute(attr.name);
//           return;
//         }

//         // Only allow a defined subset + data-*
//         if (!ALLOWED_ATTRS.has(name) && !name.startsWith("data-")) {
//           node.removeAttribute(attr.name);
//           return;
//         }

//         // Clean javascript: URLs
//         if (name === "href" || name === "src") {
//           const val = (attr.value || "").trim();
//           if (/^\s*javascript:/i.test(val)) node.removeAttribute(attr.name);
//         }

//         // Scrub style strings
//         if (name === "style") {
//           const cleaned = scrubStyleValue(attr.value || "");
//           if (cleaned) {
//             node.setAttribute("style", cleaned);
//           } else {
//             node.removeAttribute("style");
//           }
//         }
//       });
//     }

//     // Traverse children
//     [...node.childNodes].forEach(walk);
//   };

//   // Work on a wrapper to retain full fragment
//   const wrapper = document.createElement("div");
//   wrapper.appendChild(tpl.content.cloneNode(true));
//   walk(wrapper);
//   return wrapper.innerHTML;
// }

// function escapeHtml(text = "") {
//   return String(text)
//     .replace(/&/g, "&amp;")
//     .replace(/</g, "&lt;")
//     .replace(/>/g, "&gt;")
//     .replace(/"/g, "&quot;");
// }

// /**
//  * Replace {{tokens}} with bound values.
//  * Supports:
//  *  - {{experience}}, {{signature}}, {{closing}}, {{rec_strength}}, {{strength_rating}}
//  *  - {{achievements}}, {{hard_skills}}, {{soft_skills}}, {{reasons}}, {{story}}
//  * Special handling:
//  *  - tokens obey include_* flags (e.g., include_experience, include_reasons)
//  *  - Empty bindings fall back to friendly defaults where sensible
//  *  - Newlines in values are rendered as <br> for better readability
//  *  - Bound replacements are wrapped in <span data-bound="key">
//  */
// function applyBindingsToHtml(rawHtml, bindings) {
//   const {
//     // Core
//     experience = "",
//     include_experience = true,
//     signature = "",
//     closing = "",
//     rec_strength = "",
//     strength_rating = "",

//     // Evidence fields
//     achievements = "",
//     include_achievements = true,
//     hard_skills = "",
//     include_hard_skills = true,
//     soft_skills = "",
//     include_soft_skills = true,
//     reasons = "",
//     include_reasons = true,
//     story = "",
//     include_story = true,
//   } = bindings || {};

//   const defaults = {
//     experience: "—",
//     signature: "Your Name",
//     closing: "Sincerely,",
//     rec_strength: "strongly",
//     strength_rating: "5",
//     achievements: "",
//     hard_skills: "",
//     soft_skills: "",
//     reasons: "",
//     story: "",
//   };

//   let html = String(rawHtml || "");

//   const includeSwitch = {
//     experience: include_experience,
//     achievements: include_achievements,
//     hard_skills: include_hard_skills,
//     soft_skills: include_soft_skills,
//     reasons: include_reasons,
//     story: include_story,
//   };

//   const map = {
//     experience: include_experience ? (experience || defaults.experience) : "",
//     signature: signature || defaults.signature,
//     closing: closing || defaults.closing,
//     rec_strength: rec_strength || defaults.rec_strength,
//     strength_rating: String(strength_rating || defaults.strength_rating),

//     achievements: include_achievements ? (achievements || defaults.achievements) : "",
//     hard_skills: include_hard_skills ? (hard_skills || defaults.hard_skills) : "",
//     soft_skills: include_soft_skills ? (soft_skills || defaults.soft_skills) : "",
//     reasons: include_reasons ? (reasons || defaults.reasons) : "",
//     story: include_story ? (story || defaults.story) : "",
//   };

//   // Replace tokens (now includes evidence tokens)
//   html = html.replace(
//     /{{\s*(experience|signature|closing|rec_strength|strength_rating|achievements|hard_skills|soft_skills|reasons|story)\s*}}/g,
//     (_, key) => {
//       if (key in includeSwitch && !includeSwitch[key]) return "";
//       const htmlValue = escapeHtml(map[key] ?? "").replace(/\n/g, "<br>");
//       return `<span data-bound="${key}">${htmlValue}</span>`;
//     }
//   );

//   return html;
// }

// /**
//  * Preserve and restore caret position across innerHTML updates.
//  * We approximate by remembering an offset into textContent.
//  */
// function saveCaret(container) {
//   const sel = window.getSelection?.();
//   if (!sel || sel.rangeCount === 0) return null;
//   const range = sel.getRangeAt(0);
//   if (!container.contains(range.startContainer)) return null;

//   const preRange = range.cloneRange();
//   preRange.selectNodeContents(container);
//   preRange.setEnd(range.startContainer, range.startOffset);
//   const offset = preRange.toString().length;
//   return { offset };
// }

// function restoreCaret(container, saved) {
//   if (!saved) return;
//   const targetOffset = saved.offset ?? 0;
//   const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
//   let node;
//   let count = 0;
//   while ((node = walker.nextNode())) {
//     const next = count + node.textContent.length;
//     if (targetOffset <= next) {
//       const range = document.createRange();
//       const within = Math.max(0, targetOffset - count);
//       range.setStart(node, within);
//       range.collapse(true);
//       const sel = window.getSelection?.();
//       if (sel) {
//         sel.removeAllRanges();
//         sel.addRange(range);
//       }
//       return;
//     }
//     count = next;
//   }
// }

// /**
//  * Editable preview surface
//  */
// export default function LetterPreviewTemp({ html, onHtmlChange, bindings = {} }) {
//   const containerRef = useRef(null);

//   // Compute sanitized, bound HTML that should be rendered
//   const computedHtml = useMemo(() => {
//     const withBindings = applyBindingsToHtml(html, bindings);
//     return sanitizeHtml(withBindings);
//   }, [html, bindings]);

//   // Sync innerHTML when parent html/bindings change (preserve caret if focused)
//   useEffect(() => {
//     const el = containerRef.current;
//     if (!el) return;

//     const isFocused = document.activeElement === el;
//     const caret = isFocused ? saveCaret(el) : null;

//     if (el.innerHTML !== computedHtml) {
//       el.innerHTML = computedHtml;
//     }

//     if (isFocused) restoreCaret(el, caret);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [computedHtml]);

//   // Propagate edits upward with sanitized HTML
//   const handleInput = () => {
//     if (!containerRef.current || !onHtmlChange) return;
//     const current = sanitizeHtml(containerRef.current.innerHTML);
//     onHtmlChange(current);
//   };

//   // Paste handler: prefer clean plaintext; fallback to sanitized HTML
//   const handlePaste = (e) => {
//     const clipboard = e.clipboardData;
//     if (!clipboard) return; // let default happen

//     const text = clipboard.getData("text/plain");
//     if (text) {
//       e.preventDefault();
//       document.execCommand("insertText", false, text);
//       handleInput();
//       return;
//     }

//     const html = clipboard.getData("text/html");
//     if (html) {
//       e.preventDefault();
//       document.execCommand("insertHTML", false, sanitizeHtml(html));
//       handleInput();
//     }
//   };

//   return (
//     <div
//       ref={containerRef}
//       contentEditable
//       onInput={handleInput}
//       onPaste={handlePaste}
//       suppressContentEditableWarning
//       className="prose max-w-none focus:outline-none p-6 rounded-xl border border-gray-200 bg-white shadow-sm"
//       style={{ overflowWrap: "break-word" }}
//       aria-label="Editable Letter Template Preview"
//       spellCheck={true}
//       role="textbox"
//       aria-multiline="true"
//     />
//   );
// }



"use client";

import React, { useRef, useEffect, useMemo } from "react";

/**
 * Minimal, allowlist-based sanitizer that:
 *  - drops <script>, <style>, <iframe>, <object>, <embed>, <link>, <meta>
 *  - removes event handlers (on*)
 *  - cleans javascript: URLs
 *  - minimally scrubs style= values (blocks expression(), url(javascript:))
 *  - preserves common formatting + structural tags and useful attributes
 */
function sanitizeHtml(input) {
  if (typeof window === "undefined") return input || "";

  const ALLOWED_TAGS = new Set([
    // text / formatting
    "div","p","span","strong","b","em","i","u","a","ul","ol","li",
    "br","hr","h1","h2","h3","h4","h5","h6","blockquote","code","pre",
    "table","thead","tbody","tr","th","td","img","sup","sub",
    // common structure wrappers that may appear in templates
    "article","section","header","footer","address"
  ]);

  const DANGEROUS_TAGS = new Set([
    "script","style","iframe","object","embed","link","meta"
  ]);

  const ALLOWED_ATTRS = new Set([
    "class","style","href","target","rel","src","alt","title","data-bound"
  ]);

  const tpl = document.createElement("template");
  tpl.innerHTML = String(input || "");

  const scrubStyleValue = (val) => {
    if (!val) return "";
    let out = String(val);
    // block JS execution paths
    out = out.replace(/expression\s*\(/gi, "");
    out = out.replace(/url\s*\(\s*['"]?\s*javascript\s*:/gi, "url(");
    return out;
  };

  const walk = (node) => {
    if (node.nodeType === 1) {
      const tag = node.tagName.toLowerCase();

      // Remove dangerous or unknown tags (except body, which template parser may synthesize)
      if (DANGEROUS_TAGS.has(tag) || (!ALLOWED_TAGS.has(tag) && tag !== "body")) {
        node.remove();
        return;
      }

      // Scrub attributes
      [...node.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();

        // Remove any inline event handlers
        if (name.startsWith("on")) {
          node.removeAttribute(attr.name);
          return;
        }

        // Only allow a defined subset + data-*
        if (!ALLOWED_ATTRS.has(name) && !name.startsWith("data-")) {
          node.removeAttribute(attr.name);
          return;
        }

        // Clean javascript: URLs
        if (name === "href" || name === "src") {
          const val = (attr.value || "").trim();
          if (/^\s*javascript:/i.test(val)) node.removeAttribute(attr.name);
        }

        // Scrub style strings
        if (name === "style") {
          const cleaned = scrubStyleValue(attr.value || "");
          if (cleaned) {
            node.setAttribute("style", cleaned);
          } else {
            node.removeAttribute("style");
          }
        }
      });
    }

    // Traverse children
    [...node.childNodes].forEach(walk);
  };

  // Work on a wrapper to retain full fragment
  const wrapper = document.createElement("div");
  wrapper.appendChild(tpl.content.cloneNode(true));
  walk(wrapper);
  return wrapper.innerHTML;
}

function escapeHtml(text = "") {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/**
 * Replace {{tokens}} with bound values.
 * Supports:
 *  - {{experience}}, {{signature}}, {{rec_strength}}, {{strength_rating}}
 *  - {{achievements}}, {{hard_skills}}, {{soft_skills}}, {{reasons}}, {{story}}
 * Special handling:
 *  - tokens obey include_* flags (e.g., include_experience, include_reasons)
 *  - Empty bindings fall back to friendly defaults where sensible
 *  - Newlines in values are rendered as <br> for better readability
 *  - Bound replacements are wrapped in <span data-bound="key">
 * Back-compat:
 *  - Any legacy {{closing}} tokens are stripped out.
 */
function applyBindingsToHtml(rawHtml, bindings) {
  const {
    // Core
    experience = "",
    include_experience = true,
    signature = "",
    rec_strength = "",
    strength_rating = "",

    // Evidence fields
    achievements = "",
    include_achievements = true,
    hard_skills = "",
    include_hard_skills = true,
    soft_skills = "",
    include_soft_skills = true,
    reasons = "",
    include_reasons = true,
    story = "",
    include_story = true,
  } = bindings || {};

  const defaults = {
    experience: "—",
    signature: "Your Name",
    rec_strength: "strongly",
    strength_rating: "5",
    achievements: "",
    hard_skills: "",
    soft_skills: "",
    reasons: "",
    story: "",
  };

  let html = String(rawHtml || "");

  const includeSwitch = {
    experience: include_experience,
    achievements: include_achievements,
    hard_skills: include_hard_skills,
    soft_skills: include_soft_skills,
    reasons: include_reasons,
    story: include_story,
  };

  const map = {
    experience: include_experience ? (experience || defaults.experience) : "",
    signature: signature || defaults.signature,
    rec_strength: rec_strength || defaults.rec_strength,
    strength_rating: String(strength_rating || defaults.strength_rating),

    achievements: include_achievements ? (achievements || defaults.achievements) : "",
    hard_skills: include_hard_skills ? (hard_skills || defaults.hard_skills) : "",
    soft_skills: include_soft_skills ? (soft_skills || defaults.soft_skills) : "",
    reasons: include_reasons ? (reasons || defaults.reasons) : "",
    story: include_story ? (story || defaults.story) : "",
  };

  // Replace supported tokens (no 'closing')
  html = html.replace(
    /{{\s*(experience|signature|rec_strength|strength_rating|achievements|hard_skills|soft_skills|reasons|story)\s*}}/g,
    (_, key) => {
      if (key in includeSwitch && !includeSwitch[key]) return "";
      const htmlValue = escapeHtml(map[key] ?? "").replace(/\n/g, "<br>");
      return `<span data-bound="${key}">${htmlValue}</span>`;
    }
  );

  // Backward-compat: strip any legacy {{closing}} tokens if present
  html = html.replace(/{{\s*closing\s*}}/g, "");

  return html;
}

/**
 * Preserve and restore caret position across innerHTML updates.
 * We approximate by remembering an offset into textContent.
 */
function saveCaret(container) {
  const sel = window.getSelection?.();
  if (!sel || sel.rangeCount === 0) return null;
  const range = sel.getRangeAt(0);
  if (!container.contains(range.startContainer)) return null;

  const preRange = range.cloneRange();
  preRange.selectNodeContents(container);
  preRange.setEnd(range.startContainer, range.startOffset);
  const offset = preRange.toString().length;
  return { offset };
}

function restoreCaret(container, saved) {
  if (!saved) return;
  const targetOffset = saved.offset ?? 0;
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
  let node;
  let count = 0;
  while ((node = walker.nextNode())) {
    const next = count + node.textContent.length;
    if (targetOffset <= next) {
      const range = document.createRange();
      const within = Math.max(0, targetOffset - count);
      range.setStart(node, within);
      range.collapse(true);
      const sel = window.getSelection?.();
      if (sel) {
        sel.removeAllRanges();
        sel.addRange(range);
      }
      return;
    }
    count = next;
  }
}

/**
 * Editable preview surface
 */
export default function LetterPreviewTemp({ html, onHtmlChange, bindings = {} }) {
  const containerRef = useRef(null);

  // Compute sanitized, bound HTML that should be rendered
  const computedHtml = useMemo(() => {
    const withBindings = applyBindingsToHtml(html, bindings);
    return sanitizeHtml(withBindings);
  }, [html, bindings]);

  // Sync innerHTML when parent html/bindings change (preserve caret if focused)
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const isFocused = document.activeElement === el;
    const caret = isFocused ? saveCaret(el) : null;

    if (el.innerHTML !== computedHtml) {
      el.innerHTML = computedHtml;
    }

    if (isFocused) restoreCaret(el, caret);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [computedHtml]);

  // Propagate edits upward with sanitized HTML
  const handleInput = () => {
    if (!containerRef.current || !onHtmlChange) return;
    const current = sanitizeHtml(containerRef.current.innerHTML);
    onHtmlChange(current);
  };

  // Paste handler: prefer clean plaintext; fallback to sanitized HTML
  const handlePaste = (e) => {
    const clipboard = e.clipboardData;
    if (!clipboard) return; // let default happen

    const text = clipboard.getData("text/plain");
    if (text) {
      e.preventDefault();
      document.execCommand("insertText", false, text);
      handleInput();
      return;
    }

    const html = clipboard.getData("text/html");
    if (html) {
      e.preventDefault();
      document.execCommand("insertHTML", false, sanitizeHtml(html));
      handleInput();
    }
  };

  return (
    <div
      ref={containerRef}
      contentEditable
      onInput={handleInput}
      onPaste={handlePaste}
      suppressContentEditableWarning
      className="prose max-w-none focus:outline-none p-6 rounded-xl border border-gray-200 bg-white shadow-sm"
      style={{ overflowWrap: "break-word" }}
      aria-label="Editable Letter Template Preview"
      spellCheck={true}
      role="textbox"
      aria-multiline="true"
    />
  );
}
